import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../../hooks/useRequest";
import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { useSelector } from "react-redux";
import {
  Input, RenderInputFields, SubmitButton, SubInput,
  SubTab, CKEditorInput
} from "../../Form/Form";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    setValue,
    getValues,
    trigger,
    clearErrors
  } = useForm();

  const { response, request } = useRequest();
  const ckEditorRef = useRef();
  const { languages } = useSelector((state) => state.setting);
  const history = useHistory();
  const [image, setImage] = useState();
  const [displayImage, setDisplayImage] = useState();

  useEffect(() => {
    document.title = "Add Guide for Athlete- Calevalab";
  }, []);

  useEffect(() => {
    ckEditorRef.current = {};
    if (languages) {
      languages.forEach((lang) => {
        register(`description-${lang.code}`);
      });
    }
  }, [languages]);

  useEffect(() => {
    if (response) {
      toast.success("Guide has been added successfully.");
      history.push("/getting-started/guide-for-athlete");
    }
  }, [response]);


  const onSubmit = (data) => {
    const dataToSend = [];
    const defaultData = {};

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;
      dataToSend.push({
        languageCode: code,
        title: data["title-" + code],
        description: data["description-" + code],
      });
      if (languages[i].default) {
        defaultData.title = data["title-" + code];
        defaultData.description = data["description-" + code];
      }
    }

    request("POST", "getting-started/guide-for-athlete", { ...defaultData, langData: dataToSend });
  };

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Guide for Athlete"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/getting-started/guide-for-athlete", name: "Back To Guide" },
        ]}
      />
      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Add New Guide for Athlete
                  </h3>
                  <form onSubmit={handleSubmit(onSubmit)}>

                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>
                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  //   required={lang.default}
                                  required={true}
                                  InputFields={[
                                    [
                                      {
                                        Component: Input,
                                        label: "Title",
                                        type: "text",
                                        name: "title",
                                        registerFields: {
                                          required: true,
                                        },
                                      },

                                    ],
                                    [{
                                      Component: CKEditorInput,
                                      colClass: "col-xl-12",
                                      label: "Description",
                                      name: "description",
                                      registerFields: {
                                        required: false,
                                      },
                                      getValues,
                                      setValue,
                                      trigger,
                                      inputData: {
                                        onInstanceReady: (editor) => {
                                          ckEditorRef.current[lang.code] = editor;
                                        },
                                      },
                                      clearErrors,
                                      isEdit: false,
                                    }]
                                  ]}

                                  code={lang.code}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>


                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
